// extracted by mini-css-extract-plugin
module.exports = {"background":"Modal-Background-module--background--2Oh0T"};